import { getEntryState, setEntryState } from '@rad/hooks';
import { accountRoutes } from '../../../../common/routes/general';
import { STEPS } from './_state';
// Where a stop's pencil leads: the contribution the stop names, open on the story it shows when it shows
// one, to edit it there, and publish it when it is not out yet.
export const stopEditorURL = (home) => {
    const editor = accountRoutes.myPropertiesManage.getURL({ id: home.propertyId });
    return home.parcelViewId === null ? editor : `${editor}?story=${home.parcelViewId}`;
};
// The step the wizard was on when it left for a stop's editor, kept on the wizard's own history entry,
// so stepping back to it, with the editor's Back to Tour or the browser's, returns to that step.
const EDITING_FROM_STEP = 'tourWizardStep';
export const keepStep = (step) => setEntryState(EDITING_FROM_STEP, step);
export const keptStep = () => {
    const step = getEntryState(EDITING_FROM_STEP);
    return typeof step === 'number' && Number.isInteger(step) && step >= 0 && step < STEPS.length ? step : null;
};
